import { mergeClasses, Image } from '@fluentui/react-components';

import { useLogoStyles } from './Logo.styles';

export interface LogoProps {
  src: string
  className?: string
  alt?: string
}
const Logo: React.FC<LogoProps> = (props: LogoProps) => {
  const classes = useLogoStyles();
  return (
    <Image alt={props.alt} className={mergeClasses('logo', classes.container, props.className)} src={props.src}></Image>
  );
};

export default Logo;
